import React from 'react';
import cn from 'clsx';

import Button from '../../library/button/button';

import { useModal } from '../../shared/hooks/hooks';

import {
  BundleData,
  ProductData,
  StoreData
} from '../../shared/types/graphql-types';
import { CHECK_INVENTORY_DRAWER } from '../../shared/constants/modals';

import styles from './check-inventory-button.scss';

interface CheckInventoryButtonProps {
  buttonText?: React.ReactNode | string;
  className?: string;
  hideCartItems?: boolean;
  initialQuantity?: number;
  initialRearQuantity?: number;
  onCheckInventoryClick?: () => void;
  onSetStoreClick: (results: { storeData: StoreData }) => void;
  productItem?: {
    prebuiltPackage?: BundleData;
    product?: ProductData;
    productSet?: Array<ProductData>;
    rearProduct?: ProductData | null;
  };
  renderAddToCartBtn?: () => void;
  tabIndex?: number;
}

function CheckInventoryButton(props: CheckInventoryButtonProps) {
  const {
    buttonText = 'available now nearby',
    className,
    hideCartItems,
    initialQuantity,
    initialRearQuantity,
    onCheckInventoryClick,
    onSetStoreClick,
    productItem,
    renderAddToCartBtn,
    tabIndex = 0
  } = props;

  const { openModal } = useModal();

  return (
    <div className={cn(styles['container'], className)}>
      <Button
        className="check-inventory-button"
        href="/"
        onClick={e => {
          openModal(CHECK_INVENTORY_DRAWER, {
            hideCartItems,
            initialQuantity,
            initialRearQuantity,
            onSetStore: onSetStoreClick,
            onSetStoreClick,
            productItem,
            renderAddToCartBtn
          });
          onCheckInventoryClick?.();
          e.preventDefault();
          e.stopPropagation();
        }}
        size="regular"
        tabIndex={tabIndex}
      >
        {buttonText}
      </Button>
    </div>
  );
}

export default CheckInventoryButton;
